import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'

import CompanyTasksTable from './companytaskstable'

@observer(['globals', 'tasks'])
export default class NewlyAssigned extends Component {

  constructor(props) {
    super(props)
  }

  reload(callback) {
    this.props.tasks.loadAllNewlyAssignedTasks(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <CompanyTasksTable data={ this.props.tasks.new } reload={ this.reload.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks/newlyassigned.js